import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KeepAliveService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public keepAlive() {
    return this.httpClient.get(environment.urlApiPanel, {responseType: 'text'})
    .pipe(
      catchError(this.handleError)
    )
  }
}
